const ArrowDropDown = () => {
	return (
		<svg
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M16.5871 11.2341L12.9801 14.6179C12.437 15.1274 11.5596 15.1274 11.0165 14.6179L7.40946 11.2341C6.53208 10.411 7.15878 9 8.39825 9L15.6122 9C16.8517 9 17.4645 10.411 16.5871 11.2341Z'
				fill='#373D51'
			/>
		</svg>
	);
};

export default ArrowDropDown;
